<template>
  <div>
    <b-card class="mx-auto" img-src="../assets/subscribe.png" img-alt="Card image" style="max-width: 10rem;" img-top>
        <b-card-text>
          <span style="font-size: 15px">Join other knights and subscribe KOTWC below! 👇</span>
          <form>
            <div class="form-group">
              <label style="font-size: 15px">Email address</label>
              <input type="email" v-model="email" class="form-control form-control-sm" />
            </div>

            <button type="submit" @click="addSubscriber" class="btn btn-dark btn-lg btn-block" style="font-size: 15px">SUBSCRIBE</button>
          </form>
        </b-card-text>

      </b-card>
    
  </div>
</template>

<script>
import {db} from '@/firebase/init';

export default {
  name: 'SubcribeWidget',
  data(){
      return {
          email: null,
      }
  },
  methods: {
    isEmail(email) { 
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    }, 
    addSubscriber(){
      //  console.log("add sub is called");
       if(this.isEmail(this.email) == true){
       db.collection("subscribers").doc(this.email).set({
        email: this.email,
       }).then(()=>{
        //  console.log("ADDED TO LIST")
         alert("Subscription email sent, check your email to confirm");
       }).catch((err)=>{
        //  console.log("ERROR ADDING TO LIST");
         throw err;
       })
      }
      else{
        alert('Text entered was not a valid email')
      }

    }
  },
}
</script>